export const MODULE_KEYS = [
  'core',
  'storefront',
  'checkout',
  'inventory',
  'finance',
  'fiscal',
  'inbox',
  'ads',
  'agenda',
  'billing',
] as const;

export type ModuleKey = (typeof MODULE_KEYS)[number];

/** Módulos que o lojista pode contratar (core sempre ativo, billing é interno). */
export const CONTRACTABLE_MODULES = [
  'storefront',
  'checkout',
  'inventory',
  'finance',
  'fiscal',
  'inbox',
  'ads',
  'agenda',
] as const satisfies readonly ModuleKey[];

export type ContractableModuleKey = (typeof CONTRACTABLE_MODULES)[number];

export interface ModuleDefinition {
  key: ModuleKey;
  name: string;
  description: string;
  isCore: boolean;
  dependsOn: ModuleKey[];
  sortOrder: number;
}

export const MODULE_CATALOG: Record<ModuleKey, ModuleDefinition> = {
  core: {
    key: 'core',
    name: 'Núcleo',
    description: 'Cadastro do negócio, produtos, clientes, equipe e painel.',
    isCore: true,
    dependsOn: [],
    sortOrder: 0,
  },
  storefront: {
    key: 'storefront',
    name: 'Loja online',
    description: 'Sua loja na internet com tema, domínio próprio e SEO.',
    isCore: false,
    dependsOn: [],
    sortOrder: 10,
  },
  checkout: {
    key: 'checkout',
    name: 'Checkout e pagamentos',
    description: 'Carrinho, Pix, cartão e boleto, frete e painel de pedidos.',
    isCore: false,
    dependsOn: ['storefront'],
    sortOrder: 20,
  },
  inventory: {
    key: 'inventory',
    name: 'Controle de estoque',
    description: 'Entradas, saídas, reservas, inventário e alertas de estoque baixo.',
    isCore: false,
    dependsOn: [],
    sortOrder: 30,
  },
  finance: {
    key: 'finance',
    name: 'Gastos e lucros',
    description: 'Quanto entrou, quanto saiu e quanto sobrou, com DRE e fluxo de caixa.',
    isCore: false,
    dependsOn: [],
    sortOrder: 40,
  },
  fiscal: {
    key: 'fiscal',
    name: 'Notas fiscais',
    description: 'Emissão automática de NF-e, NFC-e e NFS-e.',
    isCore: false,
    dependsOn: [],
    sortOrder: 50,
  },
  inbox: {
    key: 'inbox',
    name: 'Atendimento',
    description: 'WhatsApp oficial e chat da loja numa caixa de entrada única.',
    isCore: false,
    dependsOn: [],
    sortOrder: 60,
  },
  ads: {
    key: 'ads',
    name: 'Tráfego pago',
    description: 'Campanhas de anúncios prontas, revisadas pela nossa equipe.',
    isCore: false,
    dependsOn: [],
    sortOrder: 70,
  },
  agenda: {
    key: 'agenda',
    name: 'Agenda online',
    description: 'Seus clientes marcam dia e horário pela loja, e você controla folgas e atendimentos.',
    isCore: false,
    dependsOn: ['storefront'],
    sortOrder: 15,
  },
  billing: {
    key: 'billing',
    name: 'Cobrança',
    description: 'Assinatura da plataforma (interno).',
    isCore: true,
    dependsOn: [],
    sortOrder: 99,
  },
};

export function isModuleKey(value: string): value is ModuleKey {
  return (MODULE_KEYS as readonly string[]).includes(value);
}
